import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { ISbRichtext } from '@storyblok/js';
import { RouterLinkDirective } from 'src/app/shared-extra/directives/route.directive';
import { ReplaceTextPipe } from '../../pipes/replace-text.pipe';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-text',
  standalone: true,
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    RouterLinkDirective,
    StoryblokDirective,
    BlockWrapperComponent,
    StoryblokRichTextPipe,
    ReplaceTextPipe,
  ],
})
export class TextComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() customTextAlign: string;
  @Input() lineHeight: string;

  @Input() content: ISbRichtext;
  @Input() textSize: string;
  @Input() colorOverride: string;
  @Input() alignment: string | boolean = 'center';

  @Input() mobileAlignment: string;
  @Input() tabletAlignment: string;
  @Input() desktopAlignment: string;

  ngOnChanges() {
    if (this.alignment === true) this.alignment = 'center';
  }
}
